import ClientReviewCardGroup, { ClientReviewCardGroupProps } from './ClientReviewCardGroup';

export default ClientReviewCardGroup;
export type { ClientReviewCardGroupProps };
